import TextWithReferences from '../../PageElements/TextWithReferences/TextWithReferences';
import SlotDropdown from './SlotDropdown';
import { ModuleDataDB, slotIsVisibleForUser } from '@app/common';
import { getVisibleSessionIdsForUser, slotIsFinished } from '../../../../services/DecisionTreeService/DecisionTreeService';
import PrimaryButton from '../../../atoms/PrimaryButton';
import { useAppSelector } from '../../../../store/hooks';
import { getOrderedContentIds } from '../../../../utils/contentOrder';

type Properties = {
    moduleData: ModuleDataDB;
    navigateBack: () => void;
    navigateNext: () => void;
};

const SlotOverview = (props: Properties) => {
    const { moduleData } = props;
    const moduleState = useAppSelector(state => state.moduleState.currentModuleState);
    const config = useAppSelector(state => state.globalState.config);
    const userProperties = useAppSelector(state => state.globalState.user?.userProperties)

    let moduleDone = true;

    const slotDropdowns = getOrderedContentIds(Object.keys(moduleData.slots)).reduce(
        (acc: JSX.Element[], slotId) => {
            const slot = moduleData.slots[slotId as `slot_${string}`];
            if (slotIsVisibleForUser(userProperties || [], slot, moduleState.modifiers)) {
                acc.push(
                    <SlotDropdown
                        key={slotId}
                        slotId={slotId as `slot_${string}`}
                        slotData={slot}
                    />
                );
                if (moduleState !== undefined && 
                    moduleDone && 
                    !slotIsFinished(slotId as `slot_${string}`, getVisibleSessionIdsForUser(slot, moduleState.modifiers, userProperties || []), moduleState?.finished, config?.enableTransientSessionModes === true)
                ) {
                    moduleDone = false;
                }
            }
            return acc;
        },
        [] as JSX.Element[]
    );

    return (<>
        <div className="content-module-info">
            <h1 className="module-name">{moduleData.slotsCaption}</h1>
            <p className="module-description"><TextWithReferences text={moduleData.slotsText} /></p>
        </div>
        <PrimaryButton 
            label="Startseiten des Moduls"
            onClick={props.navigateBack}
            isHidden={!moduleData.startSection}
        />
        {slotDropdowns}
        <PrimaryButton
            label="Modul abschließen"
            onClick={props.navigateNext}
            isHidden={!moduleDone || !moduleData.endSection}
        />
    </>);
};
export default SlotOverview;